import React from 'react';
import classNames from 'classnames';
import {
  DatePicker as MuiDatePicker,
  KeyboardDatePicker as MuiKeyboardDatePicker,
} from '@material-ui/pickers';
import CloseIcon from '@material-ui/icons/Close';

import cn from './DatePicker.module.scss';

const DEFAULT_FORMAT = 'MM/dd/yyyy';
const DEFAULT_PLACEHOLDER = 'MM/DD/YYYY';

export const DatePicker = ({
  onChange,
  clearable,
  className,
  allowKeyboardInput,
  ...props
}) => {
  const handleClear = () => {
    onChange(null);
  };

  const DatePickerComponent = allowKeyboardInput
    ? MuiKeyboardDatePicker
    : MuiDatePicker;

  return (
    <div className={classNames(cn.datepicker, className)}>
      <DatePickerComponent
        onChange={onChange}
        format={DEFAULT_FORMAT}
        placeholder={DEFAULT_PLACEHOLDER}
        fullWidth
        InputAdornmentProps={{
          classes: {
            root: cn.inputAdornment,
          },
        }}
        PopoverProps={{
          PaperProps: {
            classes: {
              root: cn.paper,
            },
          },
        }}
        {...props}
      />
      {clearable && (
        <CloseIcon
          color="action"
          onClick={handleClear}
          className={cn.closeIcon}
        />
      )}
    </div>
  );
};
